var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A4DEC231-E45D-4069-95CD-044944CB3A1D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-PDF-Popup",
    transform: "translate(-1226.000000, -85.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(654.000000, 85.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(572.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F0F0F0",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.503064837,
    transform: "translate(13.000000, 13.000000)",
    fill: "#010101",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.01001365,14 C0.755120619,14 0.487482931,13.8980196 0.296313154,13.7068063 C-0.0987710514,13.3116321 -0.0987710514,12.6615069 0.296313154,12.2663328 L12.2635412,0.296380606 C12.6586254,-0.0987935352 13.3086026,-0.0987935352 13.7036868,0.296380606 C14.0987711,0.691554746 14.0987711,1.34167995 13.7036868,1.73685409 L1.73645881,13.7068063 C1.51979973,13.8980196 1.26490669,14 1.01001365,14 L1.01001365,14 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9772417,14 C12.7223487,14 12.454711,13.8980196 12.2635412,13.7068063 L0.296313154,1.73685409 C-0.0987710514,1.34167995 -0.0987710514,0.691554746 0.296313154,0.296380606 C0.69139736,-0.0987935352 1.3413746,-0.0987935352 1.73645881,0.296380606 L13.7036868,12.2663328 C14.0987711,12.6615069 14.0987711,13.3116321 13.7036868,13.7068063 C13.4997724,13.8980196 13.2448794,14 12.9772417,14 L12.9772417,14 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.37283eab94501d3f6a499a9384402e6e.svg";
export { ForwardRef as ReactComponent };